<template>
  <div class="page infoscreen">
    <main>
      <div class="ovalyellow filtered"></div>
      <div class="citybg filtered"></div>
      <div class="ovalgreen filtered"></div>
      <div class="overlayinfo"></div>
      <div class="ornamentline filtered"></div>
      <levensweg-header class="info--open--header" icon="x"></levensweg-header>
      <div class="introcontainer">
        <div class="leftintroblok infoscreen">
          <img src="./../assets/img/ivf.svg" class="introbeeld hidden-sm visible-md" />
        </div>
        <div class="rightintroblok">
          <h2 class="titleslide infoopen">Klaar voor kinderen?</h2>
          <p class="bodyslide infoopen">
            Er zijn veel zaken die uw leven zin geven, voor de één horen kinderen daarbij, voor de andere niet. Maar wist je dat de vruchtbaarheid van de vrouw al begint te dalen na de leeftijd van 30?
            <br />
            <br />Kinderen vragen tijd, maar het leven stopt niet als ze er zijn. Simuleer jouw levensweg en ontdek hoe ze in jouw leven passen.
          </p>
          <div class="detweebuttons">
          <levensweg-button
            class="infoopenbutton"
            label="Start mijn levensweg"
            color="blue right"
            link="/stap1"
          />
           <levensweg-button
            class="infoopenbutton"
            label="Bijkomende info"
            color="blue right"
            link="/extrainfo"
          />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import Header from "./../components/Header";
import Levenswegbutton from "./../components/Levenswegbutton";

export default {
  components: {
    "levensweg-header": Header,
    "levensweg-button": Levenswegbutton
  }
};
</script>

<style>
.hidden-sm {
  display: none;
}

.detweebuttons{
  display: flex;
}

.ornamentline.filtered {
  background-image: url("../assets/img/line.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 254.4px;
  height: 496px;
  position: fixed;
  z-index: -2;
  filter: brightness(0) saturate(100%);
}

.ovalyellow.filtered {
  background-image: url("../assets/img/homehalfovalyellow.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 106px;
  height: 273px;
  position: fixed;
  z-index: -3;
  filter: brightness(0) saturate(100%) invert(76%) sepia(70%) saturate(397%)
    hue-rotate(121deg) brightness(84%) contrast(90%);
}
.ovalgreen.filtered {
  background-image: url("../assets/img/homehalfovalgreen.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 97px;
  height: 327px;
  position: fixed;
  bottom: 25px;
  right: 0px;
  z-index: -2;
  filter: brightness(0) saturate(100%) invert(76%) sepia(70%) saturate(397%)
    hue-rotate(121deg) brightness(84%) contrast(90%);
}

.citybg.filtered {
  background-image: url("../assets/img/city.svg");
  background-repeat: no-repeat;
  background-position: -150px 82px;
  background-size: auto 364px;
  width: 100%;
  height: 100%;
  z-index: -3;
  position: absolute;
  filter: brightness(0) saturate(100%) invert(75%) sepia(18%) saturate(1277%)
    hue-rotate(130deg) brightness(94%) contrast(90%);
}

.overlayinfo {
  background-color: rgba(81, 216, 215, 1);
  width: 100%;
  height: 100vh;
  z-index: -100;
  position: fixed;
}
.infoopen {
  color: white;
}

.info--open--header .infobutton {
  color: white;
  line-height: 1.8rem;
  filter: brightness(0) saturate(100%) invert(100%) sepia(11%) saturate(0%)
    hue-rotate(50deg) brightness(105%) contrast(101%);
}

.info--open--header a {
  color: white;
}

.infoopenbutton {
  margin-bottom: 10.46rem;
}

/* tablet */
@media only screen and (min-width: 768px) {
  .page {
    position: relative;
  }
  .ovalgreen.filtered {
    position: absolute;
  }
  .ovalyellow.filtered {
    position: absolute;
  }

  .overlayinfo {
    position: absolute;
  }
}

/*medium*/
@media only screen and (min-width: 992px) {
  .page {
    height: 700px;
  }

  .visible-md {
    display: inline;
  }

  .introcontainer {
    display: flex;
    align-items: flex-end;
  }

  .citybg.filtered {
    background-size: contain;
    background-position-x: 0px;
  }

  .introcontainer div {
    flex: 50%;
  }

  .leftintroblok {
    text-align: right;
  }

  .leftintroblok img {
    width: 80%;
    height: 80%;
  }

  .infoopenbutton {
    margin-bottom: 0;
  }

  .titleslide {
    width: 35rem;
    /*margin: 10.5rem 31.91%  0 54.83%;*/
  }
  .ornamentline.filtered {
    background-image: url("../assets/img/line.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    width: 100%;
    height: 50%; /*496px;*/
    position: absolute;
    z-index: -2;
  }
}

/* large */
@media only screen and (min-width: 1200px) {
  .ornamentline.filtered {
    width: 100%;
    height: 496px;
  }

  .citybg.filtered {
    background-position-y: 18px;
    background-position-x: -83px;
  }

  .page.infoscreen {
    height: 768px;
    max-width: 1200px;
    margin: 0 auto;
    padding-left: 83px;
    padding-right: 84px;
    overflow: hidden;
  }
  .introcontainer {
    margin-top: 10.5rem;
  }
  .overlayinfo {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .titleslide {
    font-size: 8rem;
    margin: 0;
    width: 80%;
  }

  .bodyslide {
    font-size: 1.5rem;
    width: 34.2rem;
    margin-top: 5.1rem;
    margin-bottom: 4rem;
  }
  .leftintroblok.infoscreen img {
    margin-bottom: 0;
  }

  .ovalyellow.filtered {
    background-image: url("../assets/img/ovalyellow_big.svg");
    width: 263px;
    height: 430px;
    top: 0;
  }
  .ovalgreen.filtered {
    /*background-image:url("../assets/img/ovalgreen_big.svg");*/
    width: 142px;
    height: 493px;
    bottom: 0;
    right: 0;
  }
  .info--open--header .infobutton {
    line-height: unset;
  }
  .titleslide.infoopen {
    width: 460px;
  }
}
</style>


